<div class="horizontal-scroll" #scrollingEl>
    <ng-content></ng-content>
</div>
